import {cloneDeep, get} from 'lodash'

export default {
  computed: {
    activeUser: {
      get () {
        return this.$store.getters.userInfo || this.$store.getters.activeUser
      },
      set (data) {
        if (this.$store.getters.userInfo) {
          this.$store.dispatch('setUserInfo', data)
        } else {
          this.$store.dispatch('setActiveUser', data)
        }
      }
    }
  },
  methods: {
    checkUserEmail () {
      const isDev = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV
      const gmail = get(this.activeUser, 'gmail.email', '')
      const email = get(this.activeUser, 'email', '')
      if (gmail && gmail !== email && !isDev) {
        const user = cloneDeep(this.activeUser)
        user.gmail = {}
        this.activeUser = user
        this.gmailApi.signOut()
        this.gmailApi.disconnect()
        this.gmailApi.error = 'Your gmail email does not match with account email'
        return false
      } else {
        this.gmailApi.error = ''
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/checkUserEmail.js